import { render } from "./WNWhitelist.vue?vue&type=template&id=cafa8a86&scoped=true"
import script from "./WNWhitelist.vue?vue&type=script&lang=js"
export * from "./WNWhitelist.vue?vue&type=script&lang=js"

import "./WNWhitelist.vue?vue&type=style&index=0&id=cafa8a86&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-cafa8a86"

export default script